import React, { useEffect } from "react";
import "magnific-popup";
import $ from "jquery";
import { Link } from "react-router-dom";

function Faq({ afterElment }) {
  useEffect(() => {
    /* magnificPopup video view */
    $(".popup-video").magnificPopup({
      type: "iframe",
    });
  }, []);

  return (
    <section className={afterElment + " faq-bg"}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="faq-img-wrap">
              <img src="img/images/faq_tv.png" className="img-frame" alt="" />
              <img src="img/images/faq_img.png" className="main-img" alt="" />
              <Link
                to="/https://www.youtube.com/watch?v=Jv1iolzbvZg&ab_channel=CulturaColectiva"
                className="popup-video">
                {" "}
              </Link>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="faq-wrapper">
              <div className="section-title mb-35">
                <h5 className="sub-title">Preguntas frecuentes</h5>
                <h2 className="title">¿Cómo ser parte de la comunidad?</h2>
              </div>
              <div className="accordion" id="accordionExample">
                <div className="card">
                  <div className="card-header" id="headingOne">
                    <h2 className="mb-0">
                      <button
                        className="btn btn-link btn-block text-left"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne">
                        ¿Cómo puedo contribuir a la comunidad?
                      </button>
                    </h2>
                  </div>
                  <div
                    id="collapseOne"
                    className="collapse show"
                    aria-labelledby="headingOne"
                    data-parent="#accordionExample">
                    <div className="card-body">
                      A través de nuestra app, puedes hacer donaciones directas
                      a rescatistas que trabajan arduamente para salvar animales
                      en necesidad. Además, al comprar en nuestra tienda, el 10%
                      de cada venta se destina a refugios y entidades locales.
                      Al unirte a nosotros, no solo ayudas a los animales, sino
                      que te conviertes en parte de una comunidad comprometida
                      con su bienestar.
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header" id="headingTwo">
                    <h2 className="mb-0">
                      <button
                        className="btn btn-link btn-block text-left collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo">
                        ¿Qué pasos debo seguir para adoptar una mascota?
                      </button>
                    </h2>
                  </div>
                  <div
                    id="collapseTwo"
                    className="collapse"
                    aria-labelledby="headingTwo"
                    data-parent="#accordionExample">
                    <div className="card-body">
                      Para adoptar una mascota, simplemente explora nuestra
                      sección de adopciones en la app. Allí encontrarás perfiles
                      de mascotas disponibles, junto con información sobre su
                      historia y necesidades. Una vez que encuentres a tu
                      compañero ideal, podrás contactar directamente al refugio
                      o a la persona responsable. Al adoptar, no solo le das un
                      hogar a un animal, sino que también apoyas a la comunidad
                      de rescatistas.
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header" id="headingThree">
                    <h2 className="mb-0">
                      <button
                        className="btn btn-link btn-block text-left collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree">
                        ¿Qué hacer si he perdido o encontrado una mascota?
                      </button>
                    </h2>
                  </div>
                  <div
                    id="collapseThree"
                    className="collapse"
                    aria-labelledby="headingThree"
                    data-parent="#accordionExample">
                    <div className="card-body">
                      Si has perdido una mascota, dirígete a la sección de
                      "Mascotas Perdidas" en la app y publica un aviso con
                      detalles y fotos. Si encuentras una mascota, también
                      puedes utilizar esta función para ayudar a reunificarla
                      con su dueño. La comunidad está aquí para ayudarte, y
                      juntos podemos hacer la diferencia en la vida de los
                      animales perdidos y sus familias.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="faq-shape">
        <img src="img/images/faq_shape.png" alt="" />
      </div>
    </section>
  );
}

export default Faq;
